module.exports = __webpack_public_path__ + "static/4i-9c9695b08b40f038891a8445c18f05ce.woff";